module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag05_0195AT.6503c5fe.jpg";